/**
 * Shareable view state carried in the URL query string (?lat=&lng=&q=).
 * Written with replaceState so panning doesn't spam browser history.
 */
export interface UrlState {
  lat?: number
  lng?: number
  q?: string
  z?: number
}

export function readUrlState(): UrlState {
  const params = new URLSearchParams(window.location.search)
  const lat = parseFloat(params.get('lat') ?? '')
  const lng = parseFloat(params.get('lng') ?? '')
  const z = parseFloat(params.get('z') ?? '')
  const q = params.get('q')
  return {
    ...(Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : {}),
    ...(Number.isFinite(z) && z >= 1 && z <= 20 ? { z } : {}),
    ...(q ? { q } : {}),
  }
}

export function writeUrlState(state: { lat: number; lng: number; q?: string; z?: number }): void {
  const params = new URLSearchParams()
  params.set('lat', state.lat.toFixed(5))
  params.set('lng', state.lng.toFixed(5))
  if (state.z != null) params.set('z', String(Math.round(state.z * 2) / 2))
  if (state.q) params.set('q', state.q)
  history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`)
}
